import { IAvailability } from '../../../models'
import { IFindResultAvailabilities } from '../../../models/find-result-availabilities'

export enum RouteOptionStepTypeKeys {
  FETCH_ROUTE_OPTIONS = 'FETCH_ROUTE_OPTIONS',
  FETCH_ROUTE_OPTIONS_ECORRIDOR = 'FETCH_ROUTE_OPTIONS_ECORRIDOR',
  FETCH_EARLIER_ROUTE_OPTIONS = 'FETCH_EARLIER_ROUTE_OPTIONS',
  FETCH_LATER_ROUTE_OPTIONS = 'FETCH_LATER_ROUTE_OPTIONS',
  FETCHING_ROUTE_OPTIONS = 'FETCHING_ROUTE_OPTIONS',
  FETCHING_ROUTE_OPTIONS_ECORRIDOR = 'FETCHING_ROUTE_OPTIONS_ECORRIDOR',
  FETCH_ROUTE_OPTIONS_SUCCESSFUL = 'FETCH_ROUTE_OPTIONS_SUCCESSFUL',
  FETCH_ROUTE_OPTIONS_SUCCESSFUL_ECORRIDOR = 'FETCH_ROUTE_OPTIONS_SUCCESSFUL_ECORRIDOR',
  SET_AVAILABILITY = 'SET_AVAILABILITY',
  FETCH_RETURN_ROUTE_OPTIONS = 'FETCH_RETURN_ROUTE_OPTIONS',
  FETCHING_RETURN_ROUTE_OPTIONS = 'FETCHING_RETURN_ROUTE_OPTIONS',
  FETCH_RETURN_ROUTE_OPTIONS_SUCCESSFUL = 'FETCH_RETURN_ROUTE_OPTIONS_SUCCESSFUL',
  SET_RETURN_AVAILABILITY = 'SET_RETURN_AVAILABILITY'
}

export interface IFetchRouteOptionsAction {
  type: typeof RouteOptionStepTypeKeys.FETCH_ROUTE_OPTIONS,
  payload: { navigate: boolean, alternatives?: number, onlyToday?: boolean, reservationId?: number }
}

export interface IFetchRouteOptionsEcorridorAction {
  type: typeof RouteOptionStepTypeKeys.FETCH_ROUTE_OPTIONS_ECORRIDOR
}

export interface IFetchEearlierRouteOptionsAction {
  type: typeof RouteOptionStepTypeKeys.FETCH_EARLIER_ROUTE_OPTIONS
}

export interface IFetchLaterRouteOptionsAction {
  type: typeof RouteOptionStepTypeKeys.FETCH_LATER_ROUTE_OPTIONS
}

export interface ISetIsFetchingRouteOptionsAction {
  type: typeof RouteOptionStepTypeKeys.FETCHING_ROUTE_OPTIONS
}

export interface ISetIsFetchingRouteOptionsEcorridorAction {
  type: typeof RouteOptionStepTypeKeys.FETCHING_ROUTE_OPTIONS_ECORRIDOR
}

export interface IFetchRouteOptionsSuccessfulAction {
  type: typeof RouteOptionStepTypeKeys.FETCH_ROUTE_OPTIONS_SUCCESSFUL
  payload: IFindResultAvailabilities,
  error: number
}

export interface IFetchRouteOptionsSuccessfulEcorridorAction {
  type: typeof RouteOptionStepTypeKeys.FETCH_ROUTE_OPTIONS_SUCCESSFUL_ECORRIDOR
  payload: IAvailability[]
}

export interface ISetAvailabilityAction {
  type: typeof RouteOptionStepTypeKeys.SET_AVAILABILITY
  payload: IAvailability
}

export interface IFetchReturnRouteOptionsAction {
  type: typeof RouteOptionStepTypeKeys.FETCH_RETURN_ROUTE_OPTIONS,
  payload: { navigate: boolean, alternatives?: number, onlyToday?: boolean, reservationId?: number }
}

export interface ISetIsFetchingReturnRouteOptionsAction {
  type: typeof RouteOptionStepTypeKeys.FETCHING_RETURN_ROUTE_OPTIONS
}

export interface IFetchReturnRouteOptionsSuccessfulAction {
  type: typeof RouteOptionStepTypeKeys.FETCH_RETURN_ROUTE_OPTIONS_SUCCESSFUL
  payload: IFindResultAvailabilities,
  error: number
}

export interface ISetReturnAvailabilityAction {
  type: typeof RouteOptionStepTypeKeys.SET_RETURN_AVAILABILITY
  payload: IAvailability | undefined
}

export type RouteOptionStepActionTypes =
  | IFetchRouteOptionsAction
  | IFetchRouteOptionsEcorridorAction
  | IFetchEearlierRouteOptionsAction
  | IFetchLaterRouteOptionsAction
  | ISetIsFetchingRouteOptionsAction
  | ISetIsFetchingRouteOptionsEcorridorAction
  | IFetchRouteOptionsSuccessfulAction
  | IFetchRouteOptionsSuccessfulEcorridorAction
  | ISetAvailabilityAction
  | IFetchReturnRouteOptionsAction
  | ISetIsFetchingReturnRouteOptionsAction
  | IFetchReturnRouteOptionsSuccessfulAction
  | ISetReturnAvailabilityAction
